import Vue from "vue";
import JsonExcel from "vue-json-excel";
 
export default Vue.component("downloadExcel", JsonExcel);